module.exports = __webpack_public_path__ + "static/assets/1e9eecf67923a7554eb84c91c35ebb0a.svg";